import { Box, ColorOptions, Spacer, Text } from '@jfs/ui-new'
import { useFocusEffect, useNavigation } from '@react-navigation/core'
import React, { useCallback, useState } from 'react'
import { ExpandAddView } from '../../components/ExpandAddView'
import { ListNew } from '../../components/ListNew'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { AddBankCode } from './AddBankCode'

const BankingCodes = () => {
  const navigation = useNavigation()
  const [isExpand, setIsExpand] = useState(false)
  const { accessConfig, getAllBankingCodes, bankCodes, config } = useStores((store) => ({
    bankCodes: store.bankingCode.getCodes(),
    getAllBankingCodes: store.bankingCode.getAllBankingCodes,
    config: store.user.accessConfig,
    accessConfig: store.user.getAccessConfig(['sys_control_config', 'banking_codes']),
  }))

  const searchFormRef = React.useRef(null)

  const [getAllCodesApi, { state, data }] = useLazyApiData(getAllBankingCodes)
  useFocusEffect(
    useCallback(() => {
      if (isAccessible(accessConfig, 'fetch')) {
        getAllCodesApi(searchFormRef?.current?.getValues() ?? {}, { page: 1, size: 10 })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getAllCodesApi, config]),
  )

  const keyExtractor = (item: any): string => {
    return item.id
  }

  const headTitles = [{ ID: 'ID' }, { code: 'Code' }, { name: 'Name' }, { type: 'Type' }, { status: 'Status' }]

  const fetchDataFromServer = useCallback(
    (data, paginationInfo) => {
      getAllCodesApi(data, paginationInfo)
    },
    [getAllCodesApi],
  )

  console.log('htag data =', data?.content)

  const renderList = () => {
    return (
      <ListNew
        searchFormRef={searchFormRef}
        searchData={SEARCH_FILTERS as any}
        data={data?.content}
        updatedPaginationInfo={{
          ...(data?.pageNo !== undefined && { page: data?.pageNo }),
          ...(data?.totalElements !== undefined && {
            total: data?.totalElements,
          }),
        }}
        isSearchButtonLoading={state === 'pending'}
        apiHandler={{ state, data }}
        fetchDataFromServer={fetchDataFromServer}
        keyExtractor={keyExtractor}
        headTitle={headTitles}
        sizeConfig={[0.5, 1, 1, 1, 1]}
        listTitle={'Banking Codes List'}
        hrefPath={'editBankingCode'}
        onRowItemClick={(item: any) => navigation.navigate('editBankingCode', { id: item.ID })}
      />
    )
  }
  return (
    <Box flex={1}>
      <Text title={'Banking Codes'} fontSize={28} fontWeight={'600'} color={'#5a5c69' as ColorOptions} />
      <Spacer direction="vertical" size={24} />
      {isAccessible(accessConfig, 'add') && (
        <ExpandAddView
          children={<AddBankCode onUpdate={() => setIsExpand(false)} />}
          title={'Add New Banking Code'}
          isExpand={isExpand}
          setIsExpand={setIsExpand}
        />
      )}
      <Spacer direction="vertical" size={24} />
      {isAccessible(accessConfig, 'fetch') && renderList()}
    </Box>
  )
}

export default BankingCodes

const SEARCH_FILTERS = [
  [
    { key: 'id', type: 'string', placeHolder: 'Id' },
    { key: 'code', type: 'string', placeHolder: 'Code' },
    { key: 'name', type: 'string', placeHolder: 'Name' },
  ],
  [
    { key: 'type', type: 'string', placeHolder: 'Type' },
    {
      key: 'status',
      type: 'dropdown',
      placeHolder: 'Status',
      data: [
        { id: 1, value: 'ACTIVATED' },
        { id: 2, value: 'DEACTIVATED' },
      ],
    },
  ],
]
